import { render, staticRenderFns } from "./StampCollections.vue?vue&type=template&id=1d34a0f0&scoped=true&lang=pug&"
import script from "./StampCollections.vue?vue&type=script&lang=js&"
export * from "./StampCollections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d34a0f0",
  null
  
)

export default component.exports